import React, { useState } from 'react';
import { useAuth } from "react-oidc-context";
import LoadingSpinner from './LoadingSpinner';
import '../assets/css/login.css';

function Login() {
    const auth = useAuth();
    const [loginError, setLoginError] = useState(null);

    const handleSocialLogin = async (provider) => {
        try {
            setLoginError(null);
            
            // Check if auth is available
            if (!auth) {
                setLoginError('Authentication service is not available');
                return;
            }

            // Check if signinRedirect is available
            if (!auth.signinRedirect) {
                setLoginError('Authentication redirect is not available');
                return;
            }

            // Get client ID from environment variable
            const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
            if (!clientId) {
                setLoginError('Authentication configuration is missing');
                return;
            }

            // Attempt login with more specific configuration
            await auth.signinRedirect({
                redirect_uri: window.location.origin,
                extraQueryParams: {
                    identity_provider: provider,
                    client_id: clientId,
                }
            });

        } catch (error) {
            setLoginError(`Login failed: ${error.message}`);
        }
    };

    // Loading state handling with improved UI
    if (auth?.isLoading) {
        return <LoadingSpinner message="Preparing login..." />;
    }

    // Error state handling with improved UI
    if (auth?.error || loginError) {
        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="error-message">
                        {auth?.error?.message || loginError}
                    </div>
                    <button 
                        className="login-button"
                        onClick={() => window.location.reload()}
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="login-header">
                    <h2>Welcome Back</h2>
                    <p>Please sign in with your social account</p>
                </div>

                <div className="login-form">
                    <button
                        onClick={() => handleSocialLogin('Google')}
                        className="login-button google"
                        type="button"
                    >
                        Sign in with Google
                    </button>
                    <button
                        onClick={() => handleSocialLogin('Apple')}
                        className="login-button apple"
                        type="button"
                    >
                        Sign in with Apple
                    </button>
                    <button
                        onClick={() => handleSocialLogin('Facebook')}
                        className="login-button facebook"
                        type="button"
                    >
                        Sign in with Facebook
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Login;
